export const getAffiliationCode = () => {
  const { affiliate } = window.ferryhopper;
  if (!affiliate) return 'ferryhopper';
  return affiliate;
}